<gen-dynamic-form
  class="editable-annotation-container"
  [editMode]="true"
  [disabled]="!formEditable"
  [standaloneFormConfig]="formConfig"
  [formData]="formData"
  [overrides]="formOverrides"
  (formChange)="onSave($event)"
  [formItemFullWidth]="true"
  [listenToDataChange]="true"
  ></gen-dynamic-form>